<script setup>
// import { Link } from '@inertiajs/vue3'
import SelectInput from '@/Shared/SelectInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { useForm } from '@inertiajs/vue3'
import ToggleInput from '@/Shared/ToggleInput.vue'
import Portrait from '@/Shared/Portrait.vue'
import Icon from '@/Shared/Icon.vue'

defineProps({
  players: {
    type: Array,
    default: () => []
  }
})

let form = useForm({
  player_id: '',
  is_admin: false,
  observations: ''
})

function store() {
  form.post('/coaches/store')
}

const breadcrumbs = [
  { label: 'Clases' },
  { label: 'Entrenadores', href: '/coaches' },
  { label: 'Crear' }
]
</script>

<template>
  <Portrait
    title="Crear entrenador"
    subtitle="Asigna un jugador como entrenador del club"
    :breadcrumbs="breadcrumbs"
    :footer-actions="true"
  >
    <form class="space-y-6" @submit.prevent="store">
      <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6 rounded-r-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <Icon name="InformationCircle" class="h-5 w-5 text-blue-400" />
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              Para crear un entrenador, primero debes seleccionar un jugador existente.
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-6">
        <SelectInput
          v-model="form.player_id"
          placeholder="Selecciona un jugador"
          :error="form.errors.player_id"
          label="Jugador"
        >
          <option value="" disabled>Selecciona un jugador</option>
          <option v-for="player in players" :key="player.id" :value="player.id">
            {{ player.fullname }}
          </option>
        </SelectInput>

        <ToggleInput
          v-model="form.is_admin"
          label="Permisos de administrador"
          description="Otorga permisos de administrador a este entrenador para gestionar el club"
        />

        <TextareaInput
          v-model="form.observations"
          :error="form.errors.observations"
          label="Observaciones"
          placeholder="Añade notas o comentarios sobre este entrenador"
        />
      </div>
    </form>

    <template #footer>
      <div class="flex items-center justify-end w-full">
        <LoadingButton :loading="form.processing" class="btn-indigo" @click="store">
          Crear
        </LoadingButton>
      </div>
    </template>
  </Portrait>
</template>


